const routes = [];
const autoReq = true;
if( autoReq ){
    let fileLs = require.context( '@/views', true,  /^((?!components).)*vue$/ );
    fileLs.keys().forEach( _fName => {
        //  获取组件的路径
        //  剥去文件名开头的 `'./` 和结尾的扩展名
        let _filePath    = _fName.replace(/^\.\/(.*)\.\w+$/, '$1')
        routes.push({
            name : _filePath,
            path : `/${_filePath}`,
            meta : { reqAuth: false },
            component: () => import( `@/views/${_filePath}.vue` )
        })
    } )
}

console.log( routes );
function makeRouteConf( path ){
    path.split( '/' )
}

export default routes;